import React from "react"
import { ShrinkManager } from "../ShrinkManager"
import { FiltersView } from "./Filters.view"

export interface PropsFilter {
  filters: Record<string, any>[]
  onFiltersChange: Function
  onClearFilter: Function
  className?: string
}


export function FiltersContainer(props: PropsFilter) {
  return (
    <ShrinkManager
      ShrunkedComponant={() => <FilterViewShrunked  {...props} />}
      UnShrunkedComponant={() => <FilterViewUnShrunked {...props} />}
    />)

}

const FilterViewShrunked = (props: PropsFilter) => {
  return <FiltersView Shrunked={true} {...props} />
}
const FilterViewUnShrunked = (props: PropsFilter) => {
  return <FiltersView Shrunked={false} {...props} />
}